import React, { useState, useCallback } from 'react';
import Layout from '../../components/Layout/PublicLayout/PublicLayout';

function Terms() {

    return (

        <Layout>
            <div className=' terms container'>
                <h2>Privacy Policy</h2>
                <p>

                    <strong style={{ color: "#377C58", fontSize: '18px' }}>KoopBatangan Multipurpose Cooperative</strong><br />
                    <strong>Effective Date: July 07 2025</strong><br /><br />
                    KoopBatangan Multipurpose Cooperative respects your right to privacy and is committed to safeguarding the personal information you provide to us. This Privacy Policy outlines how we collect, use, disclose, and protect your personal data in accordance with Republic Act No. 10173 or the Data Privacy Act of 2012 of the Philippines.
                </p>

                <br /><br />

                <div style={{ background: "#377C58", width: "100%", height: '2px' }}></div><br />

                <h2>Terms and Condition</h2>
                <div className="terms-and-conditions">
                    <strong style={{ color: "#377C58", fontSize: '18px' }}>KoopBatangan Multipurpose Cooperative</strong><br />
                    <strong>Effective Date: July 07 2025</strong>
                    <p>
                        Welcome to KoopBatangan Multipurpose Cooperative. By accessing or using our services, website, or becoming a member, you agree to be bound by the following Terms and Conditions.<br />
                        Please read them carefully. If you do not agree with any part, you should refrain from using our services.
                    </p>
                    <ol>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Membership Eligibility</strong>
                            <ul>
                                <li>Membership is open to individuals who meet the qualifications set by the Cooperative Development Authority (CDA) and KoopBatangan’s by-laws.</li>
                                <li>Applicants must complete all required forms, provide accurate personal information, and agree to abide by the cooperative’s rules and regulations.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Member Responsibilities</strong>
                            <p>By becoming a member, you agree to:</p>
                            <ul>
                                <li>Abide by the cooperative’s constitution, by-laws, internal policies, and code of conduct.</li>
                                <li>Fulfill your financial obligations such as capital share contributions, loan repayments, and fees.</li>
                                <li>Participate actively in the cooperative’s programs and attend general assemblies.</li>
                                <li>Keep your account information up-to-date.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Use of Services</strong>
                            <p>
                                You agree to use KoopBatangan’s services (e.g., savings, loans, insurance, online platforms) only for lawful purposes and in accordance with applicable cooperative policies.<br />
                                You must not:
                            </p>
                            <ul>
                                <li>Misrepresent your identity or financial status.</li>
                                <li>Use the cooperative’s services for fraudulent or illegal activities.</li>
                                <li>Interfere with or disrupt our services or operations.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Website and Online Platforms (if applicable)</strong>
                            <ul>
                                <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
                                <li>You must not engage in any activity that compromises system security or data integrity.</li>
                                <li>All content on the site (text, logos, images, etc.) is property of KoopBatangan and must not be used without permission.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Loans and Financial Products</strong>
                            <p>
                                Loan applications are subject to evaluation based on KoopBatangan’s credit policies. The Cooperative reserves the right to approve or deny applications at its discretion.<br />
                                Members are responsible for:
                            </p>
                            <ul>
                                <li>Understanding loan terms (interest, payment schedule, penalties).</li>
                                <li>Repaying loans on time to avoid penalties or legal actions.</li>
                                <li>Cooperating during loan collection or delinquency proceedings.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Privacy and Data Protection</strong>
                            <p>
                                We respect your privacy and handle personal information according to our Privacy Policy. By using our services, you consent to the collection, processing, and sharing of your data as necessary for cooperative operations.<br /><br />
                            </p>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Limitation of Liability</strong>
                            <ul>
                                <li>KoopBatangan is not liable for:</li>
                                <ul>
                                    <li>Any direct or indirect damages resulting from misuse of our services.</li>
                                    <li>Financial losses due to incorrect data provided by members.</li>
                                    <li>Temporary service disruptions (due to maintenance, technical issues, etc.).<br /><br /></li>
                                </ul>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Amendments to Terms</strong>
                            <p>
                                We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on our official website or announced through our branches. Continued use of our services indicates your acceptance of any updates.<br /><br />
                            </p>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Termination of Membership or Services</strong>
                            <p>
                                We may suspend or terminate your membership or access to services if:
                            </p>
                            <ul>
                                <li>You violate these Terms or cooperative by-laws.</li>
                                <li>You provide false or misleading information.</li>
                                <li>You engage in fraudulent, abusive, or unethical conduct.<br /><br /></li>
                            </ul>
                        </li>
                        <li>
                            <strong style={{ color: "#377C58", fontSize: '18px' }}>Governing Law</strong>
                            <p>
                                These Terms and Conditions shall be governed by and interpreted in accordance with the laws of the Republic of the Philippines and the rules of the Cooperative Development Authority (CDA).<br /><br />
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
        </Layout>
    );

};

export default Terms;